<div class="mt-filter filter-machine-type">
    <div class="title">
        <span class="label">{{'mine' | lang}}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-dropdown-selector
            *ngIf="mines"
            [isDisabled]="filter.uniqueSelection ? true : false"
            label="" 
            [items]="mines"
            bindLabel="name"
            bindValue="zoneId"
            [multiselect]="filter.multiselect ? true : false"
            [allSelectedOption]="filter.multiselect ? true : false"
            [ngModel]="selectedOption"
            (ngModelChange)="changeSelectedOption($event)">
        </app-dropdown-selector>
    </div>
</div>